import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import useStepClickHandler from '../hooks/useStepClickHandler';
import { getStepIconColor } from '../helpers/stepHelpers';

const Step = ({
	isComplete,
	title,
	route,
	titleSideContent,
	showStepDivider = true,
	stepKey,
	enabled
}) => {
	const labels = useLabels();
	const onClickHandler = useStepClickHandler(route, title);

	const labelStatus = isComplete
		? labels.get('COMPLETE')
		: labels.get('INCOMPLETE');

	const btnLabel =
		stepKey === 'tradeIn'
			? `${labels
					.get('ADD_A_KBB_TRADE_IN_VALUE')
					.replace('{{breakline}}', ' ')}, ${labelStatus}`
			: `${title}, ${labelStatus}`;

	const iconColor = getStepIconColor(enabled, isComplete);

	return (
		<>
			<button
				className="d-flex flex-column align-items-center btn-unstyled"
				style={{
					flexBasis: '16%',
					opacity: !enabled ? 0.5 : 1,
					cursor: !enabled ? 'not-allowed' : 'pointer'
				}}
				onClick={enabled ? onClickHandler : undefined}
				type="button"
				aria-label={enabled ? btnLabel : `${btnLabel} (not available)`}
				aria-disabled={!enabled}
				tabIndex={enabled ? 0 : -1}
			>
				<i
					className="ddc-icon-circle-check ddc-icon"
					style={{
						fontSize: '30px',
						color: iconColor
					}}
					aria-hidden="true"
				/>
				<span
					className="text-decoration-underline text-link text-link-muted ddc-font-size-xsmall"
					style={{
						textDecoration: !enabled ? 'none' : 'underline',
						...(!enabled ? { pointerEvents: 'none' } : {})
					}}
				>
					{title}
				</span>
				{titleSideContent && <div>{titleSideContent}</div>}
			</button>
			{showStepDivider && (
				<div
					className="d-flex align-self-center"
					style={{ padding: '20px 0' }}
				>
					<div className="border-right" style={{ height: '40px' }}>
						&nbsp;
					</div>
				</div>
			)}
		</>
	);
};

Step.propTypes = {
	isComplete: PropTypes.bool,
	title: PropTypes.string.isRequired,
	route: PropTypes.string.isRequired,
	titleSideContent: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	]),
	showStepDivider: PropTypes.bool,
	stepKey: PropTypes.string,
	enabled: PropTypes.bool
};

export default Step;
